import Vue from "vue";
import VueRouter from "vue-router";
import Store from "@/store";
import HomeLayout from "@/views/layout/HomeLayout.vue";
import NotFound from "@/views/error-pages/NotFound.vue";

// 解决vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: HomeLayout,
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/home/Home.vue"),
      },
      {
        path: "/play-page",
        name: "PlayPage",
        component: () => import("@/views/PlayPage.vue"),
      },
      {
        path: "/list-page",
        name: "ListPage",
        component: () => import("@/views/ListPage.vue"),
      },

      {
        path: "/download",
        name: "DownloadApp",
        component: () => import("@/views/DownloadApp.vue"),
      },

      {
        path: "/marvel-list",
        name: "MarvelList",
        component: () => import("@/views/MarvelList.vue"),
      },

      {
        path: "/old-album",
        name: "OldAlbumPage",
        component: () => import("@/views/OldAlbumPage.vue"),
      },

      {
        path: "/old-page",
        name: "OldPlayPage",
        component: () => import("@/views/OldPlayPage.vue"),
      },

      {
        path: "/search-page",
        name: "SearchPage",
        component: () => import("@/views/SearchPage.vue"),
      },
    ],
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "404-页面找不到了",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve({ ...savedPosition, behavior: "smooth" });
        } else {
          resolve({ x: 0, y: 0, behavior: "smooth" });
        }
      }, 100);
    });
  },
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  const separator = " — ";
  const title = to?.meta?.title?.trim() || "";
  title &&
    (document.title = [
      title,
      document.title.split(separator).reverse()[0],
    ].join(separator));

  if (from.name !== to.name) {
    // 添加组件缓存，只要进来的路由cache为true或数组长度不为0就直接缓存
    if (
      (Array.isArray(to?.meta?.cache ?? false) &&
        (to?.meta?.cache?.length ?? 0 > 0)) ||
      (to?.meta?.cache ?? false === true)
    ) {
      // 只要meta.cache有值且不是假值就缓存起来
      Store.commit("ADD_COMPONENTS", to.name);
    }

    // 移除组件缓存，
    // 1、循环cache值为数组的路由，
    // 2、该路由在组件缓存中
    // 3、并且该路由的cache不包含to.name
    // 4、并且当前路由也不是to.name
    // 那就从组件缓存中移除
    for (const route of router.options.routes.filter((route) =>
      Array.isArray(route?.meta?.cache ?? false)
    )) {
      if (
        Store.state.cacheComponents.includes(route.name) &&
        !route.meta.cache.includes(to.name) &&
        to.name !== route.name
      ) {
        Store.commit("REMOVE_COMPONENTS", route.name);
      }
    }
  }
  next();
});

export default router;
